import React from "react";
import { Button, Typography, Stack } from "@mui/material";
import dayjs from "dayjs";
import { invalidateBillingCaches } from "../../../shared/billing.api";

export function CacheStatusBox({
  metaData,
  setIsLoading,
  snackbarRef,
  setRenderIteration,
  renderIteration,
}) {
  return (
    <Stack>
      <Button
        variant="outlined"
        onClick={() => {
          setIsLoading(true);
          invalidateBillingCaches()
            .then(() => {
              snackbarRef.current?.addSnackbar({
                type: "success",
                message: `Successfully refreshed billing cache`,
              });
              setRenderIteration(renderIteration + 1);
              setIsLoading(false);
            })
            .catch((e) => {
              snackbarRef.current?.addSnackbar({
                type: "error",
                message: `Error refreshing billing cache: ${e.message}`,
              });
              setIsLoading(false);
            });
        }}
      >
        Refresh Caches
      </Button>
      {metaData && metaData.cache.QBtimestamp && (
        <Typography variant="caption" sx={{ mt: 1 }}>
          QB Cache Timestamp:{" "}
          {dayjs(metaData.cache.QBtimestamp).format("MMM D, YYYY h:mma")}{" "}
          <span style={{ color: "#888" }}>
            (
            {dayjs(metaData.cache.QBtimestamp).subtract(10, "second").fromNow()}
            )
          </span>
        </Typography>
      )}

      {metaData && metaData.cache.SFtimestamp && (
        <Typography variant="caption" sx={{ mt: 1 }}>
          SF Cache Timestamp:{" "}
          {dayjs(metaData.cache.SFtimestamp).format("MMM D, YYYY h:mma")}{" "}
          <span style={{ color: "#888" }}>
            (
            {dayjs(metaData.cache.SFtimestamp).subtract(10, "second").fromNow()}
            )
          </span>
        </Typography>
      )}
    </Stack>
  );
}
